import React from 'react';
import {compose, withProps, withHandlers} from 'recompose';
import {withScriptjs, withGoogleMap, GoogleMap} from 'react-google-maps';
import googleMapsStyles from '../../assets/js/googleMapsStyles';
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
const GOOGLE_MAPS_DEFAULT_LATITUDE = 46.204391;
const GOOGLE_MAPS_DEFAULT_LONGITUDE = 6.143158;

const SchoolMap = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=" + GOOGLE_MAPS_API_KEY,
        loadingElement: <div style={{height: `100%`}}/>,
        containerElement: <div style={{height: `100%`}}/>,
        mapElement: <div style={{height: `100%`}}/>,
    }),
    withHandlers(() => {
        const refs = {
            map: undefined,
        };

        return {
            onMapMounted: () => ref => {
                if (ref) {
                    refs.map = ref;
                    refs.map.panBy(0, -60);
                }
            },
        }
    }),
    withScriptjs,
    withGoogleMap
)((props) => {
    const latitude = ((props.latitude && props.latitude !== 0 && props.latitude.length > 0) ? parseFloat(props.latitude) : GOOGLE_MAPS_DEFAULT_LATITUDE);
    const longitude = ((props.longitude && props.longitude !== 0 && props.longitude.length > 0) ? parseFloat(props.longitude) : GOOGLE_MAPS_DEFAULT_LONGITUDE);

    return (
        <GoogleMap
            ref={props.onMapMounted}
            defaultZoom={16}
            center={{
                lat: latitude,
                lng: longitude,
            }}
            defaultOptions={{
                disableDefaultUI: true,
                fullscreenControl: true,
                styles: googleMapsStyles,
            }}
        >
            {(props.isMarkerShown && props.logo && props.logo.thumbnail) &&
                <InfoBox
                    defaultPosition={new window.google.maps.LatLng(latitude, longitude)}
                    options={{
                        alignBottom: true,
                        pane: 'mapPane',
                        pixelOffset: new window.google.maps.Size(-60, 0),
                        boxStyle: {
                            width: '120px',
                            height: 'auto',
                        },
                        closeBoxURL: ``,
                        enableEventPropagation: true
                    }}
                >
                    <div className="info-box-logo">
                        <div className="box">
                            <img src={props.logo.thumbnail} alt="" width={60} height={60} />
                            <div className="arrow"></div>
                        </div>
                    </div>
                </InfoBox>
            }
        </GoogleMap>
    );
});

export default SchoolMap;



// WEBPACK FOOTER //
// ./src/features/Schools/components/Details/SchoolMap.js